import React from 'react';
import { Typography } from '@mui/material';
import ActionDialog from 'common/components/ActionDialog';
import { useTranslation } from 'services/localization/useTranslation';
import { PaymentProvider } from 'common/modules/payments/types';

interface Props {
	loading: boolean;
	onRelease: () => void;
	onCancel: () => void;
	provider: PaymentProvider;
}

const CancelTransactionDialog = ({ onRelease, onCancel, loading, provider }: Props) => {
	const { t } = useTranslation();

	return (
		<ActionDialog
			title={t('cancelTransactionDialog.title', 'Do you want to release the deposit?')}
			btnActions={{
				primary: {
					text: t('common:actions.release', 'Release'),
					loading,
					disabled: loading,
					onClick: onRelease,
				},
				secondary: {
					text: t('common:actions.cancel'),
					disabled: loading,
					onClick: onCancel,
				},
			}}
			onClose={onCancel}
		>
			{provider === 'ADYEN' ? (
				<>
					<Typography gutterBottom>
						{t(
							'cancelTransactionDialog.infoMoney',
							`Releasing the deposit releases the cover reservation from the customers card. You won't be able to charge the card any longer.`,
						)}
					</Typography>
					<Typography>
						{t('common:warnings.cannotBeUndone', 'This action cannot be undone')}
					</Typography>
				</>
			) : (
				<Typography>
					{t(
						'cancelTransactionDialog.infoOther',
						'The deposit was reserved manually - remember to return the deposit to the customer!',
					)}
				</Typography>
			)}
		</ActionDialog>
	);
};

export default CancelTransactionDialog;
